module.exports = __webpack_public_path__ + "static/media/MSME_Needs_19-12-2023__1_-removebg-preview.8eded5fb.png";